import { ActionTree } from "vuex";
import Vue from "vue";

export type GtmTypes = {
  event?: string;
  eventCategory?: string;
  eventAction: string;
  eventLabel: string;
};

const state: GtmTypes = {
  event: "",
  eventCategory: "",
  eventAction: "",
  eventLabel: "",
};

interface TrackRouteProps {
  name: string;
  path: string;
}

const actions: ActionTree<GtmTypes, any> = {
  setDataLayer(
    { rootGetters: { flow } },
    { event = "event", ...eventData }: GtmTypes
  ) {
    let eventCategory = "";
    const dataLayerObj = { event, ...eventData };

    if (!eventData.eventCategory) {
      switch (flow) {
        case "PORTABILITY":
          eventCategory = "claro-flex:geral-portal-portabilidade";
          break;
        case "DELIVERY":
          eventCategory = "claro-flex:geral-sim-delivery-adquirir_numero";
          break;
        default: // MIGRATION
          eventCategory = "claro-flex:geral-portal-migracao";
          break;
      }
      dataLayerObj.eventCategory = eventCategory;
    }

    if (Vue.gtm.enabled()) {
      window.dataLayer?.push(dataLayerObj);
    }
  },
  gtmTrackRoute({ commit }, routeData: TrackRouteProps) {
    const { name, path } = routeData;
    Vue.gtm.trackView(name, path);
  },
};

export default {
  state,
  actions,
};
